import { useState } from 'react';
import ToggleButton from './ToggleButton.jsx';

/* 
Props:
  - items: { key: string, label: string, icon: React.Component, children: React.Component }[]
  - activeKey: string
  - defaultActiveKey: string
  - onChange: () => void
*/

const Tabs = ({ items, defaultActiveKey, onTabClick }) => {
  const [activeKey, setActiveKey] = useState(defaultActiveKey || items[0]?.key);

  const activeKeyIndex = items.findIndex((item) => item.key === activeKey);

  const handleTabClick = (e, key) => {
    setActiveKey(key);
    onTabClick?.(e, key);
  };

  return (
    <div className="comp-tabs">
      <ToggleButton //
        fullWidth={false}
        size="sm"
        options={items.map((item) => ({ value: item.key, label: item.label }))}
        value={activeKey}
        onChange={(key) => handleTabClick(null, key)}
        pill
        centered
      />
      <div className="content">{activeKey !== undefined && items[activeKeyIndex]?.children}</div>
    </div>
  );
};

export default Tabs;
